import React from "react";
import { Sliders, List, Settings } from "react-feather";
import { WebStories, Groups, Description, ReceiptLong, ControlPoint, Insights } from '@mui/icons-material';
import async from "../Components/Async";


const Login = async(() => import("./../pages/Login"));
const ForgotPassword = async(() => import("./../pages/ForgotPassword"));
const ResetPassword = async(() => import("./../pages/ResetPassword"));
const Dashboard = async(() => import("./../pages/Dashboard"));
const Setting = async(() => import("./../pages/Settings"));

const PlanList = async(() => import("./../pages/Plan/PlanList"));
const PlanShow = async(() => import("./../pages/Plan/PlanShow"));
const PlanShowSpecific = async(() => import("./../pages/Plan/PlanShowSpecific"));
const EditTermsAndConditionsForSpecificPlan = async(() => import("../pages/Plan/EditTerms&ConditionsForSpecificPlan.js"));
const EditSpecificPlanCertificate = async(() => import("../pages/Plan/EditSpecificPlanCertificate"));
const EditTermsAndConditions = async(() => import("./../pages/Plan/EditTerms&Conditions"));
const EditCertificate = async(() => import("../pages/Plan/EditCertificate"));

const IntermediariesList = async(() => import("./../pages/Intermediaries/IntermediariesList"));
const IntermediariesCreate = async(() => import("./../pages/Intermediaries/IntermediariesCreate"));
const IntermediariesShow = async(() => import("./../pages/Intermediaries/IntermediaryShow"));
const IntermediariesUpdate = async(() => import("./../pages/Intermediaries/IntermediariesUpdate"));
const IntermediariesUpdateEmail = async(() => import("./../pages/Intermediaries/IntermediariesUpdateEmail"));
const IntermediariesChangePassword = async(() => import("./../pages/Intermediaries/IntermediariesChangePassword"));
const SubIntermediariesCreate = async(() => import("./../pages/Intermediaries/SubIntermediaryCreate"));

const StaffList = async(() => import("./../pages/Staff/staffList"));
const StaffCreate = async(() => import("./../pages/Staff/staffCreate"));
const StaffShow = async(() => import("./../pages/Staff/staffShow"));
const StaffUpdate = async(() => import("./../pages/Staff/staffUpdate"));
const StaffUpdateEmail = async(() => import("./../pages/Staff/staffUpdateEmail"))
const StaffUpdatePassword = async(() => import("./../pages/Staff/staffChangePassword"))

const PoliciesList = async(() => import("./../pages/Policies/ListPolicies"))
const PoliciesShow = async(() => import("./../pages/Policies/ShowPolicy"))
const PoliciesUpdate = async(() => import("./../pages/Policies/PolicyUpdate"));

const Report = async(() => import("./../pages/reports"));

const Analysis = async(() => import("./../pages/Analysis/Analysis"))

const loginRoute = {
    id: "Login",
    path: "/login",
    component: Login,
    children: null
}
const forgotPasswordRoute = {
    id: "ForgotPassword",
    path: "/forgot-password",
    component: ForgotPassword,
    children: null
}
const resetPasswordRoute = {
    id: "ResetPassword",
    path: "/reset-password/:code",
    component: ResetPassword,
    children: null
}

const dashboardsRoutes = {
    id: "Dashboard",
    path: "/dashboard",
    header: "",
    icon: <Sliders />,
    containsHome: true,
    component: Dashboard
};

const settingsRoute = {
    id: "Settings",
    path: "/settings",
    icon: <Settings />,
    component: Setting
}

const plansRoutes = {
    id: "Plans",
    path: "/plans",
    icon: <WebStories />,
    component: PlanList
}

const planShowRoute = {
    id: "Plans",
    path: "/plans/show/:id",
    component: PlanShow
}

const planShowSpecificRoute = {
    id: "Plans",
    path: "/plans/show/specific/:id",
    component: PlanShowSpecific
}

const editTermsAndConditionsForSpecificPlanRoute = {
    id: "Plans",
    path: "/plans/specific/edit-terms-and-conditions/:id",
    component: EditTermsAndConditionsForSpecificPlan
}

const editSpecificPlanCertificate = {
    id: "Plans",
    path: "/plans/specific/edit-insurance-certificate/:id",
    component: EditSpecificPlanCertificate
}

const editPlanTermsAndConditionsRoute = {
    id: "Plans",
    path: "/plans/edit-terms-and-conditions/:id",
    component: EditTermsAndConditions
}

const editCertificateRoute = {
    id: "Plans",
    path: "/plans/edit-insurance-certificate/:id",
    component: EditCertificate
}

const intermediariesRoutes = {
    id: "Intermediaries",
    path: "/intermediaries",
    icon: <Groups />,
    component: IntermediariesList
}

const intermediariesCreateRoute = {
    id: "Intermediaries",
    path: "/intermediaries/create",
    component: IntermediariesCreate
}

const intermediariesShowRoute = {
    id: "Intermediaries",
    path: "/intermediaries/show/:id",
    component: IntermediariesShow
}

const intermediariesUpdateRoute = {
    id: "Intermediaries",
    path: "/intermediaries/edit/:id",
    component: IntermediariesUpdate
}

const intermediariesUpdateEmailRoute = {
    id: "Intermediaries",
    path: "/intermediaries/edit-email/:id",
    component: IntermediariesUpdateEmail
}

const intermediariesChangePasswordRoute = {
    id: "Intermediaries",
    path: "/intermediaries/change-password/:id",
    component: IntermediariesChangePassword
}

const subIntermediariesCreateRoute = {
    id: "Intermediaries",
    path: "/intermediaries/create/parent-intermediary-id=:id",
    component: SubIntermediariesCreate
}

const policiesRoutes = {
    id: "Policies",
    path: "/policies",
    icon: <Description />,
    component: PoliciesList
}
const policyShowRoute = {
    id: "Policies",
    path: "/policies/show/:id",
    component: PoliciesShow
}

const policyUpdateRoute = {
    id: "Policies",
    path: "/policies/edit/:id",
    component: PoliciesUpdate
}

const reportRoutes = {
    id: "Report",
    path: "/report",
    icon: <ReceiptLong />,
    component: Report
}

const analysisRoutes = {
    id: "Analysis",
    path: "/analysis",
    icon: <Insights />,
    component: Analysis
}

const staffRoutes = {
    id: "Staff",
    path: "/staff",
    icon: <Groups />,
    component: StaffList
}

const staffCreateRoute = {
    id: "Staff",
    path: "/staff/create",
    component: StaffCreate
}

const staffShowRoute = {
    id: "Staff",
    path: "/staff/show/:id",
    component: StaffShow
}

const staffUpdateRoute = {
    id: "Staff",
    path: "/staff/edit/:id",
    component: StaffUpdate
}

const staffUpdateEmailRoute = {
    id: "STaff",
    path: "/staff/edit-email/:id",
    component: StaffUpdateEmail
}

const staffUpdatePasswordRoute = {
    id: "STaff",
    path: "/staff/change-password/:id",
    component: StaffUpdatePassword
}

export const dashboard = [
    dashboardsRoutes,
    settingsRoute,
    plansRoutes,
    policiesRoutes,
    planShowRoute,
    planShowSpecificRoute,
    editTermsAndConditionsForSpecificPlanRoute,
    editSpecificPlanCertificate,
    editPlanTermsAndConditionsRoute,
    editCertificateRoute,
    intermediariesRoutes,
    intermediariesCreateRoute,
    intermediariesShowRoute,
    intermediariesUpdateRoute,
    intermediariesUpdateEmailRoute,
    intermediariesChangePasswordRoute,
    subIntermediariesCreateRoute,
    policyShowRoute,
    policyUpdateRoute,
    reportRoutes,
    // analysisRoutes,
    staffRoutes,
    staffCreateRoute,
    staffShowRoute,
    staffUpdateRoute,
    staffUpdateEmailRoute,
    staffUpdatePasswordRoute
]
export const auth = [];

export const unAuthRoutes = [loginRoute, forgotPasswordRoute, resetPasswordRoute];

export default [
    dashboardsRoutes,
    intermediariesRoutes,
    policiesRoutes,
    plansRoutes,
    reportRoutes,
    // analysisRoutes,
    staffRoutes,
    settingsRoute
];
